import React from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import type { StandingOrderAddressType } from 'msp-integrations'
import * as S from '../AccountStandingOrders.styles'
import { getSalutation } from '@/components/atoms/AddressDisplay/AddressDisplay'

export const StandingOrdersDetailsAddress = ({
  label,
  address
}: {
  label: string
  address: StandingOrderAddressType
}) => {
  const { formatMessage } = useIntl()
  return (
    <>
      <div className={S.DetailColumnLabel}>{label}</div>
      {(address?.c_isPackstation || address?.isPackstation) && (
        <span className={twMerge(S.DetailColumnText, 'italic')}>
          {formatMessage({
            defaultMessage: 'To the attention of :',
            id: 'msp.address_form.packstation.attention'
          })}
        </span>
      )}
      <span className={S.DetailColumnText}>{`${getSalutation(address)} ${
        address.firstName
      } ${address?.lastName}`}</span>
      <span className={S.DetailColumnText}>{`${address?.address1} ${
        address?.address2 || ''
      }`}</span>
      <span className={S.DetailColumnText}>
        {address?.countryCode}-{address?.postalCode} {address?.city}
      </span>
    </>
  )
}
